import React from "react";
import styles from "./index.module.css";
import NoResultsFoundImg from "../../assets/images/icons/no_result_icon.png";

const NoResultsFound = () => {
  return (
    <div className={styles.noResults}>
      <img
        src={NoResultsFoundImg}
        alt="No Results Found"
        className={styles.noResultsImage}
      />
    </div>
  );
};

export default NoResultsFound;
